<h1 mat-dialog-title>{{title}}</h1>
<div mat-dialog-content
  style="min-width: 300px; height: 400px;">

    <div *ngIf="!validFileSelected">
      <div style="width: 100%; margin-top: 21px;">
        <input #ebbFileInput
          style="display: none;" id="ebbFileInput"
          type="file" aria-hidden="true" title="file"
          onclick="this.value=null"
          (change)="ebbFileInputChange($event)"/>
      </div>
      <div style="margin-top: -18px !important; width: 100%;">
        <button mat-flat-button color="accent" id="receiptBrowseForFileButton"
          style="float: left; min-width:135px;"
          (click)="ebbFileInput.click()">
          BROWSE FOR FILE
        </button>
      </div>
    </div>

  
    <div  *ngIf="!validFileSelected" style="width: 100%; display: block; float: left;">
      <p *ngIf="!fileError">  {{displayFileName | Filename}}</p>
      <p *ngIf="fileError" class="mat-error"><mat-icon>warning</mat-icon> {{displayFileName | Filename}}</p>
    </div>
    <div style="width: 100%; display: block; float: left; margin-top: 9px;">
      <div
        *ngIf="!displayReceiptFields"
        style="color: #727272; min-height: 215px; margin-top: 21px;">
        <p>Only the following file types can be uploaded:</p>
        <ul>
          <li>Adobe PDF</li>
          <li>Microsoft Word DOCX</li>
          <li>Image JPG</li>
          <li>Image PNG</li>
        </ul>
        <p>The maximum file size is {{fileMaxSize}}MB.</p>
      </div>
      <div *ngIf="displayReceiptFields">
        <div *ngIf="validFileSelected"
          style="margin-bottom: 32px;">
          {{displayFileName | Filename}}
        </div>

        <form [formGroup]="formUploadReceipt" autocomplete="nope">
        <mat-form-field
          appearance="outline"
          style="width: 100%;">
          <mat-label>Receipt Type</mat-label>
          <select matNativeControl
            (change)="onChangeReceiptTypeEvent($event.target.value)"
            id="receiptType"
            name="receiptType"
            formControlName="receiptType">
              <option value=''>-- Select Type --</option>
              <option value='Contractor Invoice'>Contractor Invoice</option>
              <option value='Permit Fee'>Permit Fee</option>
              <option value='Store Receipts'>Store Receipts</option>
              <option *ngIf="data.programType === 700000002 || data.programType === 700000003"
          value='Engineer Receipts'>Engineer Receipts</option>
          </select>
          <mat-error
            *ngIf="onCheckReceiptControlValidators('receiptType')">
            Receipt type required
          </mat-error>
        </mat-form-field>
        <mat-form-field
          appearance="outline"
          style="width: 100%;">
            <mat-label>Vendor Name</mat-label>
            <input matInput required autocomplete="off"
              placeholder="Vendor Name"
              id="receiptVendor"
              name="receiptVendor"
              formControlName="receiptVendor">
            <mat-error
              *ngIf="onCheckReceiptControlValidators('receiptVendor')">
              Vendor name required
            </mat-error>
        </mat-form-field>
        <mat-form-field
          appearance="outline" id="receiptDateForm"
          style="width: 100%;">
          <mat-label>Receipt Date</mat-label>
          <input matInput autocomplete="off"
            [matDatepicker]="receiptDatePicker"
            placeholder="Receipt date"
            id="receiptDate"
            name="receiptDate"
            formControlName="receiptDate">
            <mat-datepicker-toggle matSuffix [for]="receiptDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #receiptDatePicker></mat-datepicker>
            <mat-error
              *ngIf="onCheckReceiptControlValidators('receiptDate')">
              Receipt date required
            </mat-error>
        </mat-form-field>
      </form>

    </div>
</div>

<div mat-dialog-actions style="margin-top: 9px !important; float: right !important;">

  <button mat-button id="dialogUploadReceiptCancelButton"
    (click)="onClickCancel()">
    CANCEL
  </button>
  <button mat-flat-button id="dialogUploadReceiptSaveButton"
    (click)="onClickSave()"
    color="primary"
    [disabled]="((formUploadReceipt.pristine && displayReceiptFields !== true) || formUploadReceipt.invalid) || disableFileSave">
    SAVE
  </button>

</div>
